import React from "react";
import { getClassName } from "@utils";
import { GenericSignal, SignalType } from "@types";
import { Avatar, AvatarSize } from "@taskpane/components";
import css from "./PointOfContactChangedSignalContent.module.scss";
import { ArrowsIcon } from "./icons";

export interface PointOfContactChangedSignalContentProps {
  signal: GenericSignal<SignalType.PointOfContactChanged>;
}

const PointOfContactChangedSignalContent: React.FC<PointOfContactChangedSignalContentProps> = ({
  signal,
}) => {
  const { previousMostActiveParticipantBuyerSide, currentMostActiveParticipantBuyerSide } =
    signal.eventMetadata || {};
  const [previousContactFirstName, previousContactLastName] =
    previousMostActiveParticipantBuyerSide?.name?.split(" ") || [];
  const previousContactName = previousContactLastName
    ? `${previousContactFirstName} ${previousContactLastName[0]}.`
    : previousMostActiveParticipantBuyerSide?.email || "User";

  const [currentContactFirstName, currentContactLastName] =
    currentMostActiveParticipantBuyerSide?.name?.split(" ") || [];
  const currentContactName = currentContactLastName
    ? `${currentContactFirstName} ${currentContactLastName[0]}.`
    : currentMostActiveParticipantBuyerSide?.email || "User";

  const attrs = {
    container: {
      className: css.container,
    },
    title: {
      className: css.title,
    },
    content: {
      className: css.content,
    },
    avatarWrapper: {
      className: css.avatarWrapper,
    },
    previousContactAvatar: {
      size: AvatarSize.XL,
      name: previousContactName,
      src: previousMostActiveParticipantBuyerSide?.avatar,
      className: css.avatar,
    },
    previousContactLabel: {
      className: css.label,
    },
    currentContactAvatar: {
      size: AvatarSize.XL,
      name: currentContactName,
      src: currentMostActiveParticipantBuyerSide?.avatar,
      className: getClassName(css.avatar, css.avatarActive),
    },
    currentContactLabel: {
      className: getClassName(css.label, css.labelActive),
    },
    icon: {
      className: css.icon,
    },
  };

  return (
    <div {...attrs.container}>
      <span {...attrs.title}>
        <span>Your main point of contact has</span>
        <br />
        <span>changed</span>
      </span>
      <div {...attrs.content}>
        <div {...attrs.avatarWrapper}>
          <Avatar {...attrs.previousContactAvatar} />
          <span {...attrs.previousContactLabel}>
            <span>{previousContactName}</span>
          </span>
        </div>
        <ArrowsIcon {...attrs.icon} />
        <div {...attrs.avatarWrapper}>
          <Avatar {...attrs.currentContactAvatar} />
          <span {...attrs.currentContactLabel}>
            <span>{currentContactName}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default PointOfContactChangedSignalContent;
